import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { IOrderDataTypeEnum } from "@jti/magento";
import { CheckboxInput, FormField, useFormContext, useTranslations } from "@jti/ui";
import { FormFields } from "../../../constants/checkout-constants";
import styles from "./OrderAttributeCheckbox.module.scss";
export const OrderAttributeCheckbox = ({ orderAttribute }) => {
    const { __ } = useTranslations();
    const { setValue } = useFormContext();
    const [rawValue, setRawValue] = useState(false);
    const id = `${FormFields.OrderAttributes}-${orderAttribute.code}`;
    const name = `${FormFields.OrderAttributes}.${orderAttribute.code}`;
    useEffect(() => {
        const convertValue = (value) => {
            if (orderAttribute.data_type === IOrderDataTypeEnum.Int) {
                return value ? "1" : "0";
            }
            return value ? "true" : "false";
        };
        setValue(name, convertValue(rawValue));
    }, [rawValue]);
    return (_jsx(_Fragment, { children: _jsx(FormField, { id: orderAttribute.code, name: name, defaultValue: false, className: styles.checkoutLabel, label: `${orderAttribute.is_required ? "* " : ""}${orderAttribute.label}`, render: ({ field }) => (_jsx(CheckboxInput, { ...field, value: rawValue, onChange: (value) => {
                    setRawValue(value);
                }, id: id, dataTestId: id })), checkable: true, validation: {
                ...(orderAttribute.is_required && {
                    required: {
                        value: orderAttribute.is_required,
                        message: __("form_validation.field_required"),
                    },
                }),
            } }) }));
};
//# sourceMappingURL=OrderAttributeCheckbox.js.map